import { supabase } from "@/services/supabase/createClient";

export const disableAutoRename = async (promptbookId: string) => {
  await supabase.from("promptbooks").update({ auto_rename: false }).eq("resource_id", promptbookId);
};
